import React, { useEffect, useRef, useState } from "react";
import { ItemWrapper, StyledPropertySelectWrapper } from "components/atoms/SideBar/SubMenu/Select.styles";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { NavLink, useLocation } from "react-router-dom";

const AsideSelect = ({
  className,
  title = "Select...",
  option,
  active,
  icon,
  isCollapsed,
  onClick,
}) => {
  const [value, setValue] = useState(title);
  const [dropDown, setDropDown] = useState(false);
  const closeRef = useRef();
  const location = useLocation();

  // function handelChange(elem) {
  //   setValue(elem);
  //   setDropDown(!dropDown);
  //   onChange(elem, title);
  // }
  // const handleClickOutside = (event) => {
  //   if (closeRef.current && !closeRef.current.contains(event.target)) {
  //     setDropDown(false);
  //   }
  // };
  // useEffect(() => {
  //   // Attach the event listener when the component mounts
  //   document.addEventListener("mousedown", handleClickOutside);

  //   // Detach the event listener when the component unmounts
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);
  const { hash, pathname, search } = location;
  return (
    <StyledPropertySelectWrapper
      className={className}
      $icon={dropDown}
      ref={closeRef}>
      <div
        className={`textFilter ${active ? "active" : ""} ${
          isCollapsed && "collapsed"
        }`}
        onClick={() => setDropDown(!dropDown)}>
        {value.label ? (
          <span>{value.label}</span>
        ) : (
          <span>
            <img src={icon} alt="dd" />
            {!isCollapsed && <span>{title}</span>}
          </span>
        )}
        <div className="iconWrap">
          {!isCollapsed ? (
            <MdOutlineKeyboardArrowDown size="22" color="var(--gray-400)" />
          ) : null}
        </div>
      </div>
      <ItemWrapper $height={!isCollapsed && dropDown} onClick={onClick}>
        {option?.map((elem, ind) => (
          <li key={ind}>
            <NavLink to={elem.route}>{elem.name}</NavLink>
          </li>
        ))}
      </ItemWrapper>
    </StyledPropertySelectWrapper>
  );
};

export default AsideSelect;
